import React from 'react'
import Config from "../../../config/Config";
import WidgetLoading from '../../../widget/WidgetLoading';
import JobCard from '../job/jobCard';
import NoData from '../NoData';
import { formatSalaryRange, getSalaryDisplay , tagRedirect } from '../utils'
import "./card.scss";
let filePath = Config.getFilePath();

class card extends React.Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }
  async componentDidMount() {

  }

  info = (data) => {
    const { type } = this.props;
    if (type === 'ent') {
     
      this.props.history.push({ pathname: "/home/enterprise/detail", state: { data,tabVlaue:1 } })
    } else {
      this.props.history.push({ pathname: "/home/jobdetails", state: { data } })
    }
  }

  job_info = (data) => {

    this.props.history.push({ pathname: "/home/jobdetails", state: { data } })
  }

 



  render() {
    const { data, obj, children , type } = this.props;
    // data:数据
    // type：企业 ent  岗位 job
    return <div component-data="card">
      {
        <div className='omnibus_box' >
          <div className={`sf-page-tool-between omnibus_title ${obj?.name}`}>
            {/* {obj?.title} */}
            {obj?.title_html}
            <div className='moreBtn' onClick={() => { tagRedirect(undefined,type === 'ent' ? 'enterprise' : "recommendedJob") }}>{'更多>>'}</div></div>
          {children}
          <div className={obj?.name === 'omnibus_entHot' ? `ent_box` : `job_box`}>
            {
              data && data.length > 0 ?
                data.map((item) => {

                  return obj?.name === 'omnibus_entHot' ?
                    <div className='ent_item'>
                      <div className='ent_info' onClick={() => { this.info(item) }}>
                        <img className='ent_logo' src={item?.LOGO ? filePath + 'enterprise/M' + item.id + '.png' : require("../../../img/pinzhunzhun/dataSource/ent_logo.png")} />
                        <div>
                          <div className='ent_name'>{item.ENTNAME}</div>
                          <div className='require' style={{ margin: "6px 0 0 0" }}>
                            <div className='ellipsis-text' title={item?.INDTYPE_CN}>{item.INDTYPE_CN ? item.INDTYPE_CN : ""}</div>
                            {item.SCALE_CN ? <div className='line'>|</div> : ""}
                            {item.SCALE_CN ? item.SCALE_CN : ""}
                            {item.ENTTYPE_CN ? <div className='line'>|</div> : ""}
                            {item.ENTTYPE_CN ? item.ENTTYPE_CN : ""}
                          </div>
                        </div>
                      </div>
                      <div className='ent_jobList'>
                        {

                          item?.job_load ?
                            <div className='no-data'><WidgetLoading loading={item?.job_load}></WidgetLoading></div>
                            :
                            item?.job_data && item?.job_data.length > 0 ?
                              item?.job_data.map((item) => {
                                let SAL = formatSalaryRange(item?.SALFROM, item?.SALTO);
                                let SALFROM = SAL[0];
                                let SALTO = SAL[1];
                                return <div style={{ marginBottom: '20px', cursor: "pointer" }} onClick={() => { this.job_info(item) }}>
                                  <div className='sf-page-tool-between' style={{paddingBottom:0}}>
                                    <div className='job_name'>
                                      <div className='job_JOBNAME'>{item.JOBNAME}</div>
                                      {
                                        item.IMPORTANCE === '2' ?
                                          <img className='job_jz' src={require("../../../img/pinzhunzhun/dataSource/jz.png")} /> : ""
                                      }
                                    </div>
                                    <div className='job_SAL'>
                                      {
                                        getSalaryDisplay(SALFROM, SALTO)
                                      }
                                      {item.SALPAY == "11" ? "元/小时" : ""}
                                      {item.SALPAY == "12" ? "元/天" : ""}
                                      {item.SALPAY == "13" ? "元/周" : ""}
                                    </div>
                                  </div>
                                  <div className='requireTag_box'>
                                    {item?.DISTRICT_CN ? <label>{item.DISTRICT_CN}</label> : ""}
                                    {item.REQWE_CN ? <label>{item.REQWE_CN}</label> : ""}
                                    {item.REQEDU_CN ? <label >{item.REQEDU_CN}</label> : ""}
                                    {item.REQSEX_CN ? <label >{item.REQSEX_CN}</label> : ""}
                                    {/* {!item.REQAGEFROM && !item.REQAGETO ? <label >{'不限年龄'}</label> : ""}
                                    {item.REQAGEFROM && !item.REQAGETO ? <label >{item.REQAGEFROM + '岁以上'}</label> : ""}
                                    {!item.REQAGEFROM && item.REQAGETO ? <label >{item.REQAGETO + '岁以内'}</label> : ""}
                                    {item.REQAGEFROM && item.REQAGETO ? <label >{item.REQAGEFROM + ' - ' + item.REQAGETO + '岁'}</label> : ""} */}
                                  </div>
                                </div>
                              })
                              : <NoData width={"230px"} height={'230px'} />
                        }
                        <div className='ent_more' onClick={() => { this.info(item) }}>更多职位</div>
                      </div>

                    </div>
                    :
                    <JobCard data={item} history={this.props?.history} />

                })
                : <NoData width={"230px"} height={'230px'} />
            }
          </div>

        </div>
      }
    </div>
  }
}

export default card;